/// <reference path="../../../node_modules/monaco-editor/monaco.d.ts" />

namespace Portico.Directives {

	import Inject = Portico.Decorators.Inject;
	import pme = Portico.Models.Enterprise;
	import ps = Portico.Services;

	export class ITcColorizeController {
		tcColorize: string;
		lang: string;
		content: string;
		theme?: string;
	}

	@Inject('$scope')
	export class TcColorizeController implements ITcColorizeController {
		tcColorize: string;
		lang: string;
		content: string;
		theme?: string;

		constructor(private $scope: angular.IScope) {
		}
	}

	angular.module('app').directive('tcColorize', ['$compile', '$timeout', '$sce', ($compile: angular.ICompileService, $timeout: angular.ITimeoutService, $sce: angular.ISCEService) => {
		return {
			bindToController: {
                lang: '=',
                content: '=',                
                theme: '@'
			},
			controller: <any>TcColorizeController,
			controllerAs: '$monaco',
			link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
                const tcColorize: ITcColorizeController = $ctrl[0];

				const theme = tcColorize.theme && tcColorize.theme.toLowerCase() === 'vs-dark' ? 'vs-dark':'vs';
				const content = tcColorize.content && tcColorize.content.length > 0 ? tcColorize.content : 'NULL';
				const lang = tcColorize.lang.toLowerCase();
				
				const innerHTML = $sce.trustAsHtml(content.replace(/</g, '&lt;').replace(/>/g, '&gt;'));
				const html = `<div id="monaco" class="monaco-editor" data-lang="${lang}">${innerHTML}</div>`

				$element.html(html);
				//$compile($element.contents())($scope);

				$timeout(() => {
					(<any>window).require(["vs/editor/editor.main"], () => {
						const editor = monaco.editor.colorizeElement($element[0].querySelector('#monaco'), {			
							theme						
						});
					});                   
				}, 500, true);
			},
			restrict: 'E',			
			require: ['tcColorize'],
            scope: true
		};
	}]);
}